import { IconButton } from "@mui/material";
import { SkipPreviousOutlined, SkipNextOutlined, PlayCircleOutline, PauseCircleOutlined } from "@mui/icons-material";
import { Component } from "react";

class TimerButton extends Component {

  getStyle(isEnabled) {
    return ({ color: this.props.enabled ? (this.props.iconColor || 'white') : 'red' });
  }

  render() {
    let button;
    const buttonFontSize = "var(--timer-btn-size, clamp(44px, 7vw, 72px))";
    switch(this.props.buttonType) {
      case "prev":
        button = <SkipPreviousOutlined style={this.getStyle(this.props.enabled)} sx={{ fontSize: buttonFontSize }} />;
        break;
      case "skip":
        button = <SkipNextOutlined style={this.getStyle(this.props.enabled)} sx={{ fontSize: buttonFontSize }} />;
        break;
      case "play":
        button = <PlayCircleOutline style={this.getStyle(this.props.enabled)} sx={{ fontSize: buttonFontSize }} />;
        break;
      case "pause":
        button = <PauseCircleOutlined style={this.getStyle(this.props.enabled)} sx={{ fontSize: buttonFontSize }} />;
        break;  
      default:
        break;

    }
    return (
      <IconButton className="timerControlButton" aria-label={this.props.ariaLabel || this.props.buttonType} onClick={() => this.props.onClick()}>
        {button}
      </IconButton>
    );
  }
}

export default TimerButton;
